import { Component } from "@angular/core";

import { SvgMixinComponent } from "../svg-mixin.component";

@Component({
  selector: "med-icon-invert-color",
  templateUrl: "./med-icon-invert-color.component.html",
})
export class MedIconInvertColorComponent extends SvgMixinComponent {}
